// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4862) return "static/chunks/ba2d3d3d-446e14f9102d1841.js";
	if (chunkId === 7071) return "static/chunks/7071-d550924c836fddcd.js";
	if (chunkId === 8332) return "static/chunks/8332-0ca59a55bf76d6e4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"98":"2f2366d6fb569a6b","253":"f5b6f1fd05e1e4cc","824":"edcd6df4e434988d","1459":"d583354b707dbb66","2891":"2342aadd93429994","4081":"ee6e94240df9496e","4083":"6918cf9bf79a5406","4737":"43213116da8a017f","6109":"7f8f08a2af7a9622","7287":"979756f86b796717","7371":"107573a4b1cf39ba","9860":"4d9b7538f1f7bea7"}[chunkId] + ".js";
};